import { Link } from "react-router-dom";
import ActiveBadge from "../../../../../../shared/components/badge/ActiveBadge";
import TableDeleteButton from "../../../../../../shared/components/button/TableDeleteButton";
import { DataTable } from "../../../../../../shared/components/data-table/DataTable";
import { resolveSecurityCentreUserDetail } from "../../../../../../shared/lib/routesResolver";

const UsersTable = ({ data, onDelete }) => {
  const columns = [
    {
      accessorKey: "fullname",
      header: "Nombre completo",
      cell: ({ row }) => (
        <div className="font-bold underline">
          <Link
            to={resolveSecurityCentreUserDetail(row.original.id)}
            state={{ id: row.original.id }}
          >
            {row.original.fullname}
          </Link>
        </div>
      ),
    },
    {
      accessorKey: "username",
      header: "Nombre usuario",
    },
    {
      accessorKey: "email",
      header: "Correo electrónico",
    },
    {
      accessorKey: "enabled",
      header: "Estado",
      cell: ({ row }) => <ActiveBadge booleanValue={row.getValue("enabled")} />,
    },
    {
      id: "actions",
      cell: ({ row }) => {
        const data = row.original;
        return (
          <div className="flex flex-row justify-end pr-5">
            <TableDeleteButton onClickHandler={() => onDelete(data.id)} />
          </div>
        );
      },
    },
  ];

  return <DataTable data={data} columns={columns} />;
};

export default UsersTable;
